import { FrontTable } from '@/lib';
import { DEFAULT_PAGE_SIZE } from '@/lib/Tables/parts/TablePagination/constants';
import { TablePagination } from '@/lib/Tables/parts/TablePagination/TablePagination';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ComuniList } from '../useComuniLists';
import { getUploadedListsColumns } from './getUploadedListsColumns';

type UploadedListsTableProps = {
  items: ComuniList[];
  emptyText: string;
  onOpenMapping: (list: ComuniList) => void;
  onRequestDelete: (list: ComuniList) => void;
};

export const UploadedListsTable: FC<UploadedListsTableProps> = ({ items, emptyText, onOpenMapping, onRequestDelete }) => {
  const { t } = useTranslation('comuni');
  const [pageNo, setPageNo] = useState(0);

  useEffect(() => {
    setPageNo(0);
  }, [items]);

  const columns = useMemo(() => getUploadedListsColumns({ t, onOpenMapping, onRequestDelete }), [t, onOpenMapping, onRequestDelete]);

  const pageItems = useMemo(() => items.slice(pageNo * DEFAULT_PAGE_SIZE, (pageNo + 1) * DEFAULT_PAGE_SIZE), [items, pageNo]);

  const pager = <TablePagination limit={DEFAULT_PAGE_SIZE} currentPage={pageNo + 1} totalAmount={items.length} onPageClick={setPageNo} />;

  return (
    <div className='mt-4'>
      <FrontTable tableData={pageItems} columns={columns} notFound={emptyText} isLoading={false} footer={pager} innerWrapperClassName='pb-2' />
    </div>
  );
};
